
import { Component, Vue } from 'vue-property-decorator';
import { DefaultTableVersionModel } from '@/models/default_table_version';

@Component({
  components: {
  },
})
export default class DefaultTableVersion extends Vue {
  defaultTableVersion: DefaultTableVersionModel = new DefaultTableVersionModel();
  isLoading: boolean = true;
  updating: boolean = false;

  public async created() {
    this.isLoading = true;
    await this.fetchData();
    this.isLoading = false;
  }

  public async fetchData() {
    this.isLoading = true;
    this.defaultTableVersion.name = this.$route.params.name;
    await this.defaultTableVersion.fetch();
    this.isLoading = false;
  }

  public async updateVersion() {
    this.updating = true;
    await this.defaultTableVersion.update();
    this.updating = false;
  }
}
